<template>
  <div class="news">
    <swiper
      v-if="swiper.length > 0"
      :list="swiper"
      :height="420"
    />

    <div class="news-container">
      <div v-if="introduction || news.length > 0" class="information">
        <template v-if="introduction">
          <panel title="资讯港">
            <div class="company-info">
              <img class="company-logo" :src="introduction.title">
              <div class="company-introduction">{{ introduction.context }}</div>
            </div>
          </panel>
        </template>
        <template v-if="news.length > 0">
          <panel title="资讯列表">
            <template slot="right">
              <span class="more" @click="$router.push({ name: 'newsList' })">更多 ></span>
            </template>
            <news-item
              v-for="(item, index) in news"
              :key="index"
              :value="item"
            />
          </panel>
        </template>
      </div>
      <div v-if="projects.length > 0" class="projects">
        <div class="projects-block-title">- 项目 -</div>
        <el-row :gutter="20">
          <el-col
            v-for="(item, index) in projects"
            :key="index"
            :span="8"
          >
            <div class="project-container" @click="projectDetail(item.id)">
              <img class="project-cover" :src="item.picUrl">
              <div class="project-info">
                <div class="project-title ellipsis--l2" :title="item.title">{{ item.title }}</div>
                <div class="project-content ellipsis--l3">{{ item.secondTitle }}</div>
                <div class="project-time">{{ item.createTime }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :current-page="pagination.current"
          :page-size="pagination.size"
          :total="pagination.total"
          @current-change="pageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Panel from '@/components/Panel'
import NewsItem from '@/components/NewsItem'
import Swiper from '@/components/Swiper'
import { fetchNewsBanner, fetchCompanyIntroduction, fetchNews, fetchProject } from '@/api'

export default {

  components: {
    Panel,
    NewsItem,
    Swiper
  },
  data() {
    return {
      swiper: [],

      /* 公司介绍 */
      introduction: '',

      /* 资讯 */
      news: [],

      /* 项目 */
      projects: [],
      pagination: {
        current: 1,
        size: 6,
        total: 0
      }
    }
  },

  created() {
    this.fetchBanner()
    this.fetchCompanyIntroduction()
    this.fetchNews()
    this.fetchProject()
  },

  methods: {
    /*
     * 获取banner
    */
    fetchBanner() {
      fetchNewsBanner()
        .then(res => {
          this.swiper = res.data
        })
        .catch(err => {})
    },

    /*
     * 获取公司介绍
    */
    fetchCompanyIntroduction() {
      fetchCompanyIntroduction()
        .then(res => {
          this.introduction = res.data
        })
        .catch(err => {})
    },

    /*
     * 获取资讯列表
    */
    fetchNews() {
      fetchNews({
        pageSize: 3,
        pageNo: 1
      })
        .then(res => {
          this.news = res.data.records
        })
        .catch(err => {})
    },

    /*
     * 获取项目
    */
    fetchProject(page = 1) {
      fetchProject({
        pageSize: this.pagination.size,
        pageNo: page
      })
        .then(res => {
          this.projects = res.data.records

          this.pagination.current = res.data.current
          this.pagination.total = res.data.total
        })
        .catch(err => {})
    },

    /*
     * 项目列表分页变化
    */
    pageChange(page) {
      this.fetchProject(page)
    },

    /*
     * 跳转资讯详情
    */
    newsDetail(id) {
      this.$router.push({
        name: 'newsDetail',
        query: {
          id
        }
      })
    },

    /*
     * 跳转项目详情
    */
    projectDetail(id) {
      this.$router.push({
        name: 'projectDetail',
        query: {
          id
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.news {
  padding: 0 0 60px;
  .news-container {
    max-width: 1200px;
    margin: 20px auto 0;
    .information {
      border-radius: 4px;
      background-color: #fff;
      padding: 10px 30px 20px;
      /deep/ .panel {
        .panel-header-left {
          padding: 0 0 0 10px;
          border-left: 6px solid #417EF7;
          .panel-icon {
            display: none;
          }
        }
      }
      .company-info {
        display: flex;
        padding: 30px 0;
        .company-logo {
          flex-shrink: 0;
          width: 377px;
          height: 330px;
          margin: 0 38px 0 0;
        }
        .company-introduction {
          color: #666;
          line-height: 26px;
          text-indent: 28px;
          white-space: pre-wrap;
        }
      }
      .more {
        cursor: pointer;
      }
    }
    .projects {
      margin: 45px 0 0;
      .projects-block-title {
        font-size: 20px;
        text-align: center;
        margin: 0 0 40px;
      }
      .el-col {
        &:nth-child(n + 4) {
          margin-top: 20px;
        }
      }
      .project-container {
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 1px 2px 2px 0 rgba(34,23,20,0.05);
        overflow: hidden;
        cursor: pointer;
        .project-cover {
          display: block;
          width: 100%;
          height: 224px;
        }
        .project-info {
          padding: 20px 20px 30px;
          .project-title {
            font-size: 20px;
            line-height: 28px;
            font-weight: bold;
          }
          .project-content {
            color: #666;
            line-height: 22px;
            margin: 17px 0 0;
          }
          .project-time {
            padding: 0 0 0 20px;
            font-size: 12px;
            line-height: 20px;
            color: #999;
            background-image: url('~@/assets/images/icon-clock.png');
            background-repeat: no-repeat;
            background-position: center left;
            margin: 25px 0 0;
          }
        }
      }
      .el-pagination {
        display: table;
        margin: 30px auto 0;
      }
    }
  }
}
</style>
